///////////////////////////////////////////////////////////////
//  Program: WHPayoutReport.jsx                              //
//  Application: Report                                      //
//  Option: Revenue Share Payout                             //
//  Developer: Ashish Kumar                                  //
//  Date: 2026-06-19                                         //
//                                                           //
///////////////////////////////////////////////////////////////

import React, { Component } from "react";
import ReactDatatable from "@ashvin27/react-datatable";
import { Container, Tab, Modal, InputGroup, Form } from "react-bootstrap";
import AllPropertyPayoutSidebar from "../common/AllPropertyPayoutSidebar";
import PayoutSidebar from "../common/PayoutSidebar";
import SimpleReactValidator from "simple-react-validator";
import DatePicker from "react-datepicker";
import WHPayoutService from "../../services/WHPayoutService";
import StripePayoutService from "../../services/StripePayoutService";
import UnitsService from "../../services/UnitsService";
import Select from "react-select";
import Moment from "moment";
import MultiImageService from "../../services/MultiImageService";
import SuccessLogo from "./../../assets/images/successImage.svg";
import OutSidePropertySelectBox from "../outside-modules/OutSidePropertySelectBox";
import Alerts from "../common/Alerts";

class WHPayoutReport extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.checkInToDateInputGroupRef = React.createRef();
    this.checkInFromDateInputGroupRef = React.createRef();
    this.sendReportStartDateInputGroupRef = React.createRef();
    this.sendReportEndDateInputGroupRef = React.createRef();
    this.state = {
      checkInToDatePlacement: "bottom-start",
      checkInFromDatePlacement: "bottom-start",
      sendReportStartDatePlacement: "bottom-start",
      sendReportEndDatePlacement: "bottom-start",
      errors: {},
      isSubmit: false,
      tableQueryString: "",
      customQueryString: "",
      showFilter: global.showFilter,
      is_by_paid: 1,
      module_search: "",
      module_search_display: "",
      exportMesssage: "",
      exportFilePath: "",
      alertType: "xlsx",
      is_search: 0,
      isSearch: global.isSearch,
      input: {},
      selectedPaymentStatusList: { value: "all", label: "All" },
      selectedIntroPaymentStatusList: { value: "all", label: "All" },
      intro_pay_status_slug: "all",
      intro_pay_status_lable: "All",
      introPaymentStatusList: [],
      showAlertModal: false,
      alertModalType: "",
      alertModalTitle: "",
      alertModalMessage: "",
      filter_value: "",
      loading: false,
      showSpinner: false,
      total_record: 0,
      pay_status_slug: "all",
      pay_status_lable: "All",
      // Scope to the property from the URL when this page is opened from a
      // specific property's payout menu — otherwise this stayed "" and the
      // report silently fetched every property's WH payout rows regardless
      // of which property's page the user was actually on.
      property_slug: this.props.match.params.propertySlug || "",
      outSidePropertySlug: this.props.match.params.propertySlug || "",
      selectedPropertyList: [],
      start_date: "",
      end_date: "",
      // Manual, on-demand report email — independent of the Search/Export
      // filters above and of the automated cadence-based report. Its own
      // date fields so opening this modal never clobbers whatever the user
      // already has selected in the Search modal.
      sendReportModal: false,
      sendReportStartDate: "",
      sendReportEndDate: "",
      isSendingReport: false,
      // Unit filter
      unitList: [],
      newUnitList: [],
      selectedUnitList: [],
      unit_slug: "",
      unit_lable: "",
      // Creditor filter — options come from this.state.creditors (already loaded
      // in getData() for the Stripe onboarding cards), not a separate API call.
      selectedCreditorList: "",
      creditor_id: "",
      creditor_lable: "",
      totalOwed: 0,
      totalPaid: 0,
      // WH Introductory Brokerage Fee — tracked independently of totalOwed/totalPaid above.
      totalIntroOwed: 0,
      totalIntroPaid: 0,
      // Per-creditor Stripe connection status — only used here to gate the
      // Send Transfer/Send Intro Transfer buttons below. The actual Stripe
      // Connect/cadence setup UI lives in its own module now, since a
      // creditor's Stripe account is a global setting, not something scoped
      // to one property's revenue-share report — see CreditorStripeSetup.jsx.
      creditors: [],
      Stripebalance: 0,
      // Result of the last "Send Transfer"/"Send Intro Transfer" click —
      // { transferred: [...], skipped: [...] }, shown in the success modal.
      lastTransferResult: null,
      // Transfer panel — WH FF&E Brokerage Fee
      is_total: false,
      confirmPay: false,
      isTransfer: false,
      importTransferResponseModel: false,
      successTranferMessage: "",
      // Transfer panel — WH Introductory Brokerage Fee (independent transfer, same Stripe account)
      is_total_intro: false,
      confirmPayIntro: false,
      isTransferIntro: false,
      records: [],
      config: {
        sort: {
          column: "",
          order: "",
        },
        key_column: "slug",
        page_size: global.page_size,
        length_menu: global.page_length_menu,
        show_length_menu: true,
        show_filter: global.show_filter,
        show_pagination: true,
        pagination: "advance",
        button: {
          excel: global.excel_button,
          print: global.print_button,
          extra: false,
        },
        language: {
          no_data_text: "No data found",
        },
      },
      paymentStatusList: [],
      extraButtons: [],
      columns: [
        {
          key: "property_name",
          text: "Property",
          className: "hand-cursor text-center td_clickable",
          cell: (record) => {
            return record.property_name || "";
          },
        },
        {
          key: "unit_number",
          text: "Unit",
          className: "hand-cursor text-center td_clickable",
          cell: (record) => {
            return record.unit_number || record.unit_name || "";
          },
        },
        {
          key: "creditor",
          text: "Creditor",
          className: "hand-cursor text-center td_clickable",
          cell: (record) => {
            // The synthetic Totals row spans every creditor, so a "-" here
            // would misleadingly read as "no creditor" rather than "N/A".
            if (record.slug === "wh-payout-totals-row") return "";
            return record.creditor || "-";
          },
        },
        {
          key: "reservation_count",
          text: "Reservations",
          className: "hand-cursor text-center td_clickable",
          cell: (record) => {
            return record.reservation_count || 0;
          },
        },
        {
          // Short column labels on purpose — the "FF&E Brokerage" /
          // "Introductory Brokerage" group name is already shown once in
          // the .wh-payout-group-header bar above this table, so repeating
          // the full fee name on every column both crowded the header and
          // forced uneven column widths that no longer lined up with that
          // bar's 3-equal-thirds split.
          key: "payout_wh",
          text: "FF&E Brokerage Fee %",
          className: "hand-cursor text-center td_clickable",
          cell: (record) => {
            // A blended FF&E % across every unit's own rate isn't a
            // meaningful figure, so the Totals row leaves this blank
            // instead of showing "-" (which would read as missing data).
            if (record.slug === "wh-payout-totals-row") return "";
            return record.payout_wh != null && record.payout_wh !== ""
              ? parseFloat(record.payout_wh).toFixed(1).replace(/\.0$/, "") + "%"
              : "-";
          },
        },
        {
          key: "ffe_unpaid_amount",
          text: "FF&E Brokerage Fee Unpaid",
          className: "hand-cursor text-center td_clickable",
          cell: (record) => {
            return this.renderAmountCell(record.ffe_unpaid_amount, true);
          },
        },
        {
          key: "ffe_paid_amount",
          text: "FF&E Brokerage Fee Paid",
          className: "hand-cursor text-center td_clickable",
          cell: (record) => {
            return this.renderAmountCell(record.ffe_paid_amount, false);
          },
        },
        {
          key: "payout_intro",
          text: "Introductory Brokerage Fee %",
          className: "hand-cursor text-center td_clickable",
          cell: (record) => {
            // Same reasoning as the FF&E % column above — a blended rate
            // across units isn't meaningful, so Totals stays blank.
            if (record.slug === "wh-payout-totals-row") return "";
            return record.payout_intro != null &&
              record.payout_intro !== ""
              ? parseFloat(record.payout_intro).toFixed(1).replace(/\.0$/, "") + "%"
              : "-";
          },
        },
        {
          key: "intro_unpaid_amount",
          text: "Introductory Brokerage Fee Unpaid",
          className: "hand-cursor text-center td_clickable",
          cell: (record) => {
            return this.renderAmountCell(record.intro_unpaid_amount, true);
          },
        },
        {
          key: "intro_paid_amount",
          text: "Introductory Brokerage Fee Paid",
          className: "hand-cursor text-center td_clickable",
          cell: (record) => {
            return this.renderAmountCell(record.intro_paid_amount, false);
          },
        },
      ],
    };
    this.changeHandler = this.changeHandler.bind(this);
    this.clearFilter = this.clearFilter.bind(this);
    this.getData = this.getData.bind(this);
  }

  componentDidMount() {
    // Must scope the initial load to the URL's property — getData(""), the
    // old behavior, hit the bare "wh-payout" endpoint with no property_slug
    // filter at all, so every property's WH payout rows showed up on every
    // property's page.
    this.getData("property_slug=" + (this.state.property_slug || ""));
    this.getStripeBalance();
  }

  getStripeBalance = async () => {
    let res = await StripePayoutService.getstripebalance();
    if (global.successStatus.includes(res.status)) {
      this.setState({
        Stripebalance: res.data.Stripe_balance ? res.data.Stripe_balance : 0,
      });
    }
  };

  getPropertySlug(property_slug) {
    this.setState({
      property_slug: property_slug,
      outSidePropertySlug: property_slug,
    });
    setTimeout(() => {
      // Pass property_slug explicitly rather than relying on this.state having
      // flushed by the time this timeout fires — same bug as componentDidMount,
      // getData() with no args ignored the selected property entirely.
      this.getData("property_slug=" + (property_slug || ""));
    }, 200);
    this.setState({
      module_search: [],
      is_search: 0,
    });
  }

  getData = async (queryString = "") => {
    this.setState({ showSpinner: true, loading: true });
    var list = [];
    var totalRecords = 0;
    let totalOwed = 0;
    let totalPaid = 0;
    let totalIntroOwed = 0;
    let totalIntroPaid = 0;
    let creditors = this.state.creditors;

    let res = await WHPayoutService.getWHPayoutReport(queryString);
    if (global.successStatus.includes(res.status)) {
      list = res.data ? res.data.data || [] : [];
      totalRecords = res.data ? res.data.total || 0 : 0;
      totalOwed = res.data ? res.data.total_owed || 0 : 0;
      totalPaid = res.data ? res.data.total_paid || 0 : 0;
      totalIntroOwed = res.data ? res.data.total_intro_owed || 0 : 0;
      totalIntroPaid = res.data ? res.data.total_intro_paid || 0 : 0;
      creditors = res.data && res.data.creditors ? res.data.creditors : [];
    }
    this.setState({
      showSpinner: false,
      loading: false,
      total_record: totalRecords,
      records: list,
      totalOwed: totalOwed,
      totalPaid: totalPaid,
      totalIntroOwed: totalIntroOwed,
      totalIntroPaid: totalIntroPaid,
      creditors: creditors,
    });
  };

  async ExportData() {
    this.setState({ showSpinner: true, isSubmit: true });
    let startDate = this.state.start_date
      ? Moment(this.state.start_date).format("YYYY-MM-DD")
      : "";
    let endDate = this.state.end_date
      ? Moment(this.state.end_date).format("YYYY-MM-DD")
      : "";
    let queryString =
      "&is_export=1" +
      "&file_type=" +
      this.state.alertType +
      "&property_slug=" +
      (this.state.property_slug ? this.state.property_slug : "") +
      "&start_date=" +
      startDate +
      "&end_date=" +
      endDate +
      "&wh_payout_status=" +
      (this.state.pay_status_slug ? this.state.pay_status_slug : "");

    let res = await WHPayoutService.getWHPayoutReport(queryString);
    if (
      global.successStatus.includes(res.status) &&
      res.data &&
      res.data.filePath
    ) {
      this.getDownloadFile(res.data.filePath, res.data.fileName);
      this.setState({ exportMesssage: res.message, exportFilePath: res.data.filePath });
    } else {
      this.setState({
        exportMesssage: res.message || "No data found for the selected filters.",
      });
    }
    this.setState({ showSpinner: false, isSubmit: false });
  }

  async getDownloadFile(url, name) {
    let file_name = name.split(".")[0];
    var queryString = "path=" + url + "&display_file_name=" + file_name;
    this.setState({ showSpinner: true, loading: true });
    let inputData = {};
    var resData = {};
    await MultiImageService.downloadFile(inputData, queryString);
    this.setState(resData);
    this.setState({ showSpinner: false, loading: false });
  }

  toggleSendReportModal = () => {
    if (this.state.sendReportModal) {
      this.setState({ sendReportModal: false });
    } else {
      this.setState({
        sendReportModal: true,
        sendReportStartDate: "",
        sendReportEndDate: "",
      });
    }
  };

  // Emails the report for the chosen range to Cindy/John (cc Tech) — same
  // recipients as the automated cadence report, but this send is one-off
  // and does not touch the cadence schedule at all.
  sendManualReport = async () => {
    if (!this.state.sendReportStartDate || !this.state.sendReportEndDate) {
      this.setState({
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: "Error!",
        alertModalMessage: "Select both a start date and an end date.",
      });
      setTimeout(
        () => this.setState({ showAlertModal: false }),
        global.alert_close_time,
      );
      return;
    }

    this.setState({ isSendingReport: true });
    // Forward whatever filters are currently applied on screen (property,
    // unit, creditor, FF&E/Intro status) so the emailed report matches what
    // the admin is actually looking at — previously this only sent the date
    // range, so the email silently ignored any active Search filter.
    let unit_search = this.state.unit_slug
      ? Array.isArray(this.state.unit_slug)
        ? this.state.unit_slug.join(",")
        : this.state.unit_slug
      : "";
    let res = await WHPayoutService.sendManualWhPayoutReport({
      start_date: Moment(this.state.sendReportStartDate).format("YYYY-MM-DD"),
      end_date: Moment(this.state.sendReportEndDate).format("YYYY-MM-DD"),
      property_slug: this.state.property_slug || "",
      unit_slug: unit_search,
      creditor_id: this.state.creditor_id || "",
      wh_payout_status:
        this.state.pay_status_slug && this.state.pay_status_slug !== "all"
          ? this.state.pay_status_slug
          : "",
      intro_payout_status:
        this.state.intro_pay_status_slug &&
        this.state.intro_pay_status_slug !== "all"
          ? this.state.intro_pay_status_slug
          : "",
    });
    this.setState({
      isSendingReport: false,
      sendReportModal: !global.successStatus.includes(res.status),
      showAlertModal: true,
      alertModalType: global.successStatus.includes(res.status)
        ? "success"
        : "error",
      alertModalTitle: global.successStatus.includes(res.status)
        ? "Success"
        : res.data
          ? res.data.errorCode || "Error!"
          : "Error!",
      alertModalMessage: global.successStatus.includes(res.status)
        ? res.message || "Report sent."
        : res.data
          ? res.data.errorMessage || res.data.message
          : "Failed to send report.",
    });
    setTimeout(
      () => this.setState({ showAlertModal: false }),
      global.alert_close_time,
    );
  };

  exportToggle = () => {
    if (this.state.isModel === 1) {
      this.setState({ exportMesssage: "" });
      this.setState({ isModel: 0 });
      this.setState({ showSpinner: false, isSubmit: false });
    } else {
      this.setState({ isModel: 1 });
    }
  };

  changeExport(evt) {
    let value = evt.target.value;
    this.setState({ alertType: value });
  }

  async getUnitData(queryString = "") {
    this.setState({ showSpinner: true, loading: true });
    var unitList = [];
    var unitListTotal = 0;
    let res = await UnitsService.getUnitsList(
      "is_dropdown=1&property_slug=" +
        (this.state.property_slug ? this.state.property_slug : ""),
      queryString ? "&" + queryString : "",
    );
    if (global.successStatus.includes(res.status)) {
      unitList = res.data ? res.data : [];
      unitListTotal = unitList ? unitList.length : 0;
    }
    const newUnitList =
      unitListTotal > 0
        ? unitList.map(({ slug, unit_name }) => ({
            value: slug,
            label: unit_name,
          }))
        : [];
    this.setState({
      unitList: unitList,
      newUnitList: newUnitList,
      showSpinner: false,
      loading: false,
    });
  }

  handleChangeUnitList(value) {
    let unit_slug = [];
    let unit_lable = [];
    if (value != null && value.length > 0) {
      value.forEach((item) => {
        unit_slug.push(item.value);
        unit_lable.push(item.label);
      });
    }
    this.setState({
      selectedUnitList: value,
      unit_slug: unit_slug,
      unit_lable: unit_lable,
    });
  }

  handleChangeCreditorList(value) {
    this.setState({
      selectedCreditorList: value,
      creditor_id: value ? value.value : "",
      creditor_lable: value ? value.label : "",
    });
  }

  async clearFilter() {
    this.setState({ is_search: 0, is_by_paid: 1 });
    this.setState({
      start_date: "",
      end_date: "",
      unit_slug: "",
      unit_lable: "",
      selectedUnitList: [],
      selectedPaymentStatusList: { value: "all", label: "All" },
      pay_status_slug: "all",
      pay_status_lable: "All",
      selectedIntroPaymentStatusList: { value: "all", label: "All" },
      intro_pay_status_slug: "all",
      intro_pay_status_lable: "All",
      selectedCreditorList: "",
      creditor_id: "",
      creditor_lable: "",
    });
    this.setState({
      module_search: "",
      paymentStatusList: "",
    });
    // Must keep the property scope — getData() with no args drops the
    // property_slug filter and mixes every property's rows together, same
    // bug already fixed for the initial load in componentDidMount.
    this.getData("property_slug=" + (this.state.property_slug || ""));
  }

  totalbill = () => {
    if (this.state.is_total === true) {
      this.setState({ is_total: false });
    } else {
      this.setState({ is_total: true });
    }
  };

  confirmPayClose = () => {
    if (this.state.confirmPay === true) {
      this.setState({ confirmPay: false });
    } else {
      this.setState({ confirmPay: true });
      this.setState({ is_total: false });
    }
  };

  // Intro fee transfer — mirrors totalbill/confirmPayClose above, independent
  // modal state so opening one transfer flow never affects the other.
  totalbillIntro = () => {
    if (this.state.is_total_intro === true) {
      this.setState({ is_total_intro: false });
    } else {
      this.setState({ is_total_intro: true });
    }
  };

  confirmPayCloseIntro = () => {
    if (this.state.confirmPayIntro === true) {
      this.setState({ confirmPayIntro: false });
    } else {
      this.setState({ confirmPayIntro: true });
      this.setState({ is_total_intro: false });
    }
  };

  closeTransferResponseModel() {
    this.setState({
      importTransferResponseModel: false,
      lastTransferResult: null,
    });
  }

  paymentpayout = async () => {
    this.setState({ isTransfer: true });
    let postData = {};

    // Only apply filters when the user has explicitly searched — the property
    // dropdown alone does not filter the report (getData ignores it), so sending
    // property_slug from state when is_search===0 would mismatch the visible records.
    if (this.state.is_search === 1) {
      let startDate = this.state.start_date
        ? Moment(this.state.start_date).format("YYYY-MM-DD")
        : "";
      let endDate = this.state.end_date
        ? Moment(this.state.end_date).format("YYYY-MM-DD")
        : "";
      let unit_search = this.state.unit_slug
        ? Array.isArray(this.state.unit_slug)
          ? this.state.unit_slug.join(",")
          : this.state.unit_slug
        : "";
      if (this.state.property_slug) {
        postData.property_slug = this.state.property_slug;
      }
      if (unit_search) {
        postData.unit_slug = unit_search;
      }
      if (startDate) {
        postData.start_date = startDate;
      }
      if (endDate) {
        postData.end_date = endDate;
      }
    }

    let res = await WHPayoutService.whStripeTransfer(postData);
    if (global.successStatus.includes(res.status)) {
      this.getData(this.state.customQueryString);
      this.getStripeBalance();
    }
    // Money is auto-split across every creditor with an unpaid FF&E balance —
    // res.data.transferred/skipped list each creditor's own result.
    this.setState({
      is_total: false,
      confirmPay: false,
      isTransfer: false,
      importTransferResponseModel: true,
      lastTransferResult: res.data || null,
      successTranferMessage: global.successStatus.includes(res.status)
        ? res.message
          ? res.message
          : "Payment Transfer Successfully"
        : res.data
          ? res.data.errorMessage || res.data.message
          : "Transfer failed.",
    });
  };

  // Intro fee transfer — same shape as paymentpayout() above, calling the
  // Introductory Brokerage Fee's own Stripe transfer endpoint.
  paymentpayoutIntro = async () => {
    this.setState({ isTransferIntro: true });
    let postData = {};

    if (this.state.is_search === 1) {
      let startDate = this.state.start_date
        ? Moment(this.state.start_date).format("YYYY-MM-DD")
        : "";
      let endDate = this.state.end_date
        ? Moment(this.state.end_date).format("YYYY-MM-DD")
        : "";
      let unit_search = this.state.unit_slug
        ? Array.isArray(this.state.unit_slug)
          ? this.state.unit_slug.join(",")
          : this.state.unit_slug
        : "";
      if (this.state.property_slug) {
        postData.property_slug = this.state.property_slug;
      }
      if (unit_search) {
        postData.unit_slug = unit_search;
      }
      if (startDate) {
        postData.start_date = startDate;
      }
      if (endDate) {
        postData.end_date = endDate;
      }
    }

    let res = await WHPayoutService.whIntroStripeTransfer(postData);
    if (global.successStatus.includes(res.status)) {
      this.getData(this.state.customQueryString);
      this.getStripeBalance();
    }
    this.setState({
      is_total_intro: false,
      confirmPayIntro: false,
      isTransferIntro: false,
      importTransferResponseModel: true,
      lastTransferResult: res.data || null,
      successTranferMessage: global.successStatus.includes(res.status)
        ? res.message
          ? res.message
          : "Payment Transfer Successfully"
        : res.data
          ? res.data.errorMessage || res.data.message
          : "Transfer failed.",
    });
  };

  filterToggle = () => {
    if (this.state.showFilter === 1) {
      this.setState({ showFilter: 0 });
    } else {
      this.setState({ showFilter: 1 });
    }
  };

  searchToggle = () => {
    if (this.state.isSearch === 1) {
      this.setState({ isSearch: 0 });
    } else {
      this.getUnitData();
      this.setState({ isSearch: 1 });
      const paymentStatusList = [
        { value: "all", label: "All" },
        { value: "0", label: "Unpaid" },
        { value: "1", label: "Paid" },
      ];
      this.setState({
        paymentStatusList: paymentStatusList,
        introPaymentStatusList: paymentStatusList,
      });
    }
  };

  handleChangePaymentStatusList(value) {
    const unit_slug_value = value !== null ? value.value : "all";
    const selected_label = value !== null ? value.label : "All";
    this.setState({ is_by_paid: 0 });
    this.setState({
      selectedPaymentStatusList: value,
      pay_status_slug: unit_slug_value,
      pay_status_lable: selected_label,
    });
  }

  // Intro fee status filter — independent of the WH status filter above.
  handleChangeIntroPaymentStatusList(value) {
    const unit_slug_value = value !== null ? value.value : "all";
    const selected_label = value !== null ? value.label : "All";
    this.setState({ is_by_paid: 0 });
    this.setState({
      selectedIntroPaymentStatusList: value,
      intro_pay_status_slug: unit_slug_value,
      intro_pay_status_lable: selected_label,
    });
  }

  customValidate() {
    let isValid = true;
    return isValid;
  }

  // Live collected % (paid / (owed + paid)) — the reference mockup showed a
  // hardcoded "0% collected", but this report already has both totals in
  // state, so there is no reason to show a placeholder instead of the real
  // figure.
  renderKpiCard = (title, owed, paid) => {
    const owedNum = parseFloat(owed) || 0;
    const paidNum = parseFloat(paid) || 0;
    const denominator = owedNum + paidNum;
    const collectedPct =
      denominator > 0 ? Math.round((paidNum / denominator) * 100) : 0;
    return (
      <div className="wh-payout-kpi-card">
        <div className="kpi-head">
          <span className="kpi-title">{title}</span>
          <span className="kpi-pct">{collectedPct}% collected</span>
        </div>
        <div className="kpi-nums">
          <div className="num">
            <div className="n owed">
              $
              {global.onKeyPressEvent.numberWithCommasForDecimal(
                owedNum.toFixed(2).replace(/\.00$/, ""),
              )}
            </div>
            <div className="cap">Total owed</div>
          </div>
          <div className="num">
            <div className="n paid">
              $
              {global.onKeyPressEvent.numberWithCommasForDecimal(
                paidNum.toFixed(2).replace(/\.00$/, ""),
              )}
            </div>
            <div className="cap">Total paid</div>
          </div>
        </div>
        <div className="kpi-bar">
          <span style={{ width: collectedPct + "%" }}></span>
        </div>
      </div>
    );
  };

  // "Unpaid"/"Paid" cell styling shared by both fee-type columns — zero
  // values stay muted (existing convention), non-zero unpaid gets the same
  // tinted-red "owed" treatment already used for Stripe status pills
  // elsewhere in this app, non-zero paid gets the matching green.
  renderAmountCell = (value, isUnpaid) => {
    const num = parseFloat(value) || 0;
    const formatted =
      "$" +
      global.onKeyPressEvent.numberWithCommasForDecimal(
        num.toFixed(2).replace(/\.00$/, ""),
      );
    if (num === 0) {
      return <span className="wh-cell-zero">{formatted}</span>;
    }
    return (
      <span className={isUnpaid ? "wh-cell-owed" : "wh-cell-paid"}>
        {formatted}
      </span>
    );
  };

  // Appends a synthetic "Totals" row to the records ReactDatatable renders,
  // instead of a separate div sitting outside the <table>. A sibling div
  // there collided with ReactDatatable's own pagination footer — this
  // table sits inside the shared .Report_table wrapper (used by 32 other
  // report screens), which forces that footer's position with a fixed
  // pixel offset tuned for "nothing follows the table". Making the totals
  // row a genuine last row of the table's own tbody sidesteps that
  // entirely: it renders through the exact same columns/cell renderers as
  // real rows (so the red/green amount styling is automatic), and the
  // pagination footer — unchanged, still just following the whole table —
  // now correctly ends up below it instead of on top of it.
  recordsWithTotals = () => {
    const records = this.state.records || [];
    if (records.length === 0) {
      return records;
    }
    const totalsRow = {
      slug: "wh-payout-totals-row",
      property_name:
        "Totals — " +
        this.state.total_record +
        " unit" +
        (this.state.total_record === 1 ? "" : "s"),
      // A single space, not "", for these two — the existing cell
      // renderers do `record.unit_number || record.unit_name || ""` and
      // `record.reservation_count || 0`, so an empty (falsy) string would
      // fall through and show a stray "0" here instead of staying blank.
      unit_number: " ",
      reservation_count: " ",
      payout_wh: null,
      ffe_unpaid_amount: this.state.totalOwed,
      ffe_paid_amount: this.state.totalPaid,
      payout_intro: null,
      intro_unpaid_amount: this.state.totalIntroOwed,
      intro_paid_amount: this.state.totalIntroPaid,
    };
    return [...records, totalsRow];
  };

  getResponsivePlacement = (ref) => {
    if (!ref.current) return "bottom-start";

    const rect = ref.current.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const CALENDAR_HEIGHT_ESTIMATE = 330;
    const CALENDAR_WIDTH_ESTIMATE = 300;

    if (spaceBelow >= CALENDAR_HEIGHT_ESTIMATE || window.innerWidth <= 767) {
      return "bottom-start";
    }

    const spaceRight = window.innerWidth - rect.right;
    const spaceLeft = rect.left;

    if (spaceRight >= CALENDAR_WIDTH_ESTIMATE) return "right-start";
    if (spaceLeft >= CALENDAR_WIDTH_ESTIMATE) return "left-start";
    return spaceRight >= spaceLeft ? "right-start" : "left-start";
  };

  checkCheckInToDatePlacement = () => {
    this.setState({
      checkInToDatePlacement: this.getResponsivePlacement(this.checkInToDateInputGroupRef),
    });
  };

  checkCheckInFromDatePlacement = () => {
    this.setState({
      checkInFromDatePlacement: this.getResponsivePlacement(this.checkInFromDateInputGroupRef),
    });
  };

  checkSendReportStartDatePlacement = () => {
    this.setState({
      sendReportStartDatePlacement: this.getResponsivePlacement(this.sendReportStartDateInputGroupRef),
    });
  };

  checkSendReportEndDatePlacement = () => {
    this.setState({
      sendReportEndDatePlacement: this.getResponsivePlacement(this.sendReportEndDateInputGroupRef),
    });
  };

  changeHandler = async (event) => {
    let input = this.state.input;
    let value =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    input[event.target.name] = value;
    await this.setState({ [event.target.name]: value, input: input });
    this.validator.showMessageFor(event.target.name);
    this.customValidate();
  };

  async filterData() {
    let startDate = this.state.start_date
      ? Moment(this.state.start_date).format("YYYY-MM-DD")
      : "";
    let endDate = this.state.end_date
      ? Moment(this.state.end_date).format("YYYY-MM-DD")
      : "";
    // The Search modal shows "Check In To Date" (bound to end_date) to the
    // LEFT of "Check In From Date" (bound to start_date) — reversed from
    // natural chronological order, per an earlier explicit field-reorder
    // request. That layout leads users to type the earlier date into the
    // left (To) field and the later date into the right (From) field,
    // producing a start_date after end_date. A date RANGE is symmetric
    // regardless of which field each date landed in, so swapping here
    // (rather than trusting field order) both fixes the query and keeps
    // the "Search Applied On" chip below showing the dates in the right
    // order, without re-touching the requested field layout.
    if (startDate && endDate && startDate > endDate) {
      [startDate, endDate] = [endDate, startDate];
    }
    let unit_search = this.state.unit_slug
      ? Array.isArray(this.state.unit_slug)
        ? this.state.unit_slug.join(",")
        : this.state.unit_slug
      : "";
    let queryString =
      "property_slug=" +
      (this.state.property_slug ? this.state.property_slug : "") +
      "&unit_slug=" +
      unit_search +
      "&start_date=" +
      startDate +
      "&end_date=" +
      endDate +
      "&wh_payout_status=" +
      (this.state.pay_status_slug && this.state.pay_status_slug !== "all"
        ? this.state.pay_status_slug
        : "") +
      "&intro_payout_status=" +
      (this.state.intro_pay_status_slug &&
      this.state.intro_pay_status_slug !== "all"
        ? this.state.intro_pay_status_slug
        : "") +
      "&creditor_id=" +
      (this.state.creditor_id ? this.state.creditor_id : "") +
      "&is_search=1";

    let searchDisplay = "";
    let comma = ",";

    if (this.state.unit_lable && this.state.unit_lable.length > 0) {
      searchDisplay =
        (searchDisplay !== "" ? searchDisplay + comma : searchDisplay) +
        " Unit: " +
        (Array.isArray(this.state.unit_lable)
          ? this.state.unit_lable.join(", ")
          : this.state.unit_lable);
    }
    if (this.state.start_date) {
      searchDisplay =
        (searchDisplay !== "" ? searchDisplay + comma : searchDisplay) +
        " Start Date: " +
        Moment(startDate).format("MM/DD/YY");
    }
    if (this.state.end_date) {
      searchDisplay =
        (searchDisplay !== "" ? searchDisplay + comma : searchDisplay) +
        " End Date: " +
        Moment(endDate).format("MM/DD/YY");
    }
    if (this.state.pay_status_lable && this.state.pay_status_lable.length > 0) {
      searchDisplay =
        (searchDisplay !== "" ? searchDisplay + comma : searchDisplay) +
        " FF&E Status: " +
        this.state.pay_status_lable;
    }
    if (
      this.state.intro_pay_status_lable &&
      this.state.intro_pay_status_lable.length > 0
    ) {
      searchDisplay =
        (searchDisplay !== "" ? searchDisplay + comma : searchDisplay) +
        " Intro Status: " +
        this.state.intro_pay_status_lable;
    }
    if (this.state.creditor_lable && this.state.creditor_lable.length > 0) {
      searchDisplay =
        (searchDisplay !== "" ? searchDisplay + comma : searchDisplay) +
        " Creditor: " +
        this.state.creditor_lable;
    }

    this.setState({ customQueryString: queryString });
    this.searchToggle();
    this.setState({ is_search: 1, is_by_paid: 0 });
    this.setState({ module_search_display: searchDisplay.split(",") });
    this.getData(queryString);
  }

  tableChangeHandler = (data) => {
    let queryString = Object.keys(data)
      .map((key) => {
        if (key === "sort_order" && data[key]) {
          return (
            encodeURIComponent("sort_order") +
            "=" +
            encodeURIComponent(data[key].order) +
            "&" +
            encodeURIComponent("sort_column") +
            "=" +
            encodeURIComponent(data[key].column)
          );
        } else {
          let newKey = key;
          if (key === "page_number") {
            newKey = "page";
          } else if (key === "page_size") {
            newKey = "per_page";
          } else if (key === "sort_order") {
            data[key] = "asc";
          }
          return (
            encodeURIComponent(newKey) + "=" + encodeURIComponent(data[key])
          );
        }
      })
      .join("&");

    if (data.filter_value !== "") {
      this.setState({ tableQueryString: queryString });
    } else {
      queryString += "&" + this.state.customQueryString;
      this.setState({ tableQueryString: queryString });
    }

    if (data.filter_value !== this.state.filter_value) {
      clearTimeout(this.state.filter_time);
      this.setState({
        filter_time: setTimeout(
          () => this.getData(queryString),
          global.filter_time,
        ),
        filter_value: data.filter_value,
      });
    } else {
      this.getData(queryString);
    }
  };

  rowClickedHandler = (event, data, rowIndex) => {};

  render() {
    const customStyles = {
      option: (provided, state) => ({
        ...provided,
        color:
          state.isSelected && state.isFocused
            ? "white"
            : state.isSelected
              ? "black"
              : state.isFocused && "white",
        backgroundColor:
          state.isSelected && state.isFocused
            ? "black"
            : state.isFocused && "black",
      }),
    };

    return (
      <>
        <main>
          <Container className="innter-container">
            <div className="d-flex flex-column">
              <div className="row row-xs mg-t-0 pd-t-0 pd-lg-l-15 pd-xs-l-0">
                <div className="col-md-2 left">
                  <div className="child-menu-section">
                    {this.props.match.params.propertySlug !== undefined ? (
                      <PayoutSidebar property_slug={this.state.property_slug} />
                    ) : (
                      <AllPropertyPayoutSidebar
                        property_slug={this.state.property_slug}
                      />
                    )}
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="col-md-12 mg-t-20 mg-b-10"></div>
                  <div className="col-md-12 mg-t-0 mg-b-10 pd-t-0 pd-b-10 pd-l-15 pd-r-0">
                    <div className="dashbaord-pageHeadertitle d-flex justify-content-between align-items-center flex-nowrap mg-b-0 payable_head wh-payout-header-band">
                      <h3>Revenue Share Payout</h3>
                      <div className="d-flex justify-content-end flex-nowrap pd-l-0 pd-r-0 mg-b-0 wh-payout-header-actions">
                        <button
                          className="btn-success-outline-small button-width ml-3"
                          onClick={this.searchToggle}
                        >
                          Search
                        </button>
                        {global.userPermissions.checkPermission(
                          "wh-payout-report-list",
                        ) ? (
                          <button
                            className="btn-success-outline-small mr-0"
                            onClick={this.exportToggle}
                          >
                            Export
                          </button>
                        ) : (
                          ""
                        )}
                        {global.userPermissions.checkPermission(
                          "wh-payout-report-add",
                        ) && (
                          <button
                            className="btn-success-outline-small ml-3"
                            onClick={this.toggleSendReportModal}
                          >
                            Send Report
                          </button>
                        )}
                        {global.userPermissions.checkPermission(
                          "wh-payout-report-add",
                        ) &&
                          this.state.creditors.some(
                            (c) => c.ffe_stripe_status === "active",
                          ) && (
                            <button
                              disabled={this.state.totalOwed == 0}
                              disableElevation
                              className="btn-success ml-3 button-width-cust btn-disable-theme-payout"
                              onClick={this.totalbill}
                            >
                              Send FF&E Brokerage Fee Transfer
                            </button>
                          )}
                        {global.userPermissions.checkPermission(
                          "wh-payout-report-add",
                        ) &&
                          this.state.creditors.some(
                            (c) => c.intro_stripe_status === "active",
                          ) && (
                            <button
                              disabled={this.state.totalIntroOwed == 0}
                              disableElevation
                              className="btn-success ml-3 button-width-cust btn-disable-theme-payout"
                              onClick={this.totalbillIntro}
                            >
                              Send Introductory Brokerage Fee Transfer
                            </button>
                          )}
                      </div>
                    </div>
                  </div>

                  <div className="col-md-12 pd-l-15 pd-r-15">
                    <Alerts
                      show={this.state.showAlertModal}
                      type={this.state.alertModalType}
                      title={this.state.alertModalTitle}
                      message={this.state.alertModalMessage}
                    />
                  </div>

                  {/* Creditor Stripe account setup (Connect/cadence) now lives in its
                      own module — see CreditorStripeSetup.jsx under Payouts — since
                      it's a per-creditor setting, not something scoped to one
                      property's revenue-share report. This report only reads
                      this.state.creditors to gate the Send Transfer buttons above. */}

                  <div className="col-md-12 mg-t-0 mg-b-10 pd-t-0 pd-b-10 pd-lg-l-0 pd-lg-r-15 pd-xs-r-0">
                    {this.props.match.params.propertySlug === undefined ? (
                      <div className="row pd-lg-l-15 pd-xs-l-15">
                        <div className="col-xxl-2 col-sm-3 pd-lg-r-0 pd-xs-r-15 pd-lg-l-45 pd-xs-l-15">
                          <OutSidePropertySelectBox
                            propertySlug={this.getPropertySlug.bind(this)}
                            outSidePropertySlug={this.state.outSidePropertySlug}
                          />
                        </div>
                        <div className="col-xxl-10 col-md-9 col-sm-8 pd-r-15 pd-l-15">
                          {this.state.is_search === 1 ? (
                            this.state.module_search_display ? (
                              <div className="col-xxl-12 col-sm-12 pd-xs-l-30 d-inline-flex align-items-start justify-content-end justify_mob_filter scrolling-carousel">
                                <div className="custm-filter">
                                  <div>
                                    <label className="form-label text-left pd-b-2 mb-0">
                                      Search Applied On
                                    </label>
                                  </div>
                                  <div className="filter_bg_cust">
                                    {this.state.module_search_display.map(
                                      (item, i) => {
                                        return <span key={i}>{item}</span>;
                                      },
                                    )}
                                    <button
                                      onClick={this.clearFilter}
                                      className="btn-fliter-clear"
                                    >
                                      Clear
                                    </button>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              ""
                            )
                          ) : (
                            <div className="col-xxl-12 col-sm-12 pd-xs-l-30 d-inline-flex align-items-start justify-content-end justify_mob_filter scrolling-carousel">
                              <div className="custm-filter">
                                <div>
                                  <label className="form-label text-left pd-b-2 mb-0">
                                    Search Applied On
                                  </label>
                                </div>
                                <div className="filter_bg_cust">
                                  <span>
                                    Status - {this.state.pay_status_lable}
                                  </span>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="col-xxl-12 pd-r-15 pd-l-15">
                        {this.state.is_search === 1 ? (
                          this.state.module_search_display ? (
                            <div className="col-xxl-12 col-sm-12 pd-xs-l-30 d-inline-flex align-items-start justify-content-end justify_mob_filter scrolling-carousel">
                              <div className="custm-filter">
                                <div>
                                  <label className="form-label text-left pd-b-2 mb-0">
                                    Search Applied On
                                  </label>
                                </div>
                                <div className="filter_bg_cust">
                                  {this.state.module_search_display.map(
                                    (item, i) => {
                                      return <span key={i}>{item}</span>;
                                    },
                                  )}
                                  <button
                                    onClick={this.clearFilter}
                                    className="btn-fliter-clear"
                                  >
                                    Clear
                                  </button>
                                </div>
                              </div>
                            </div>
                          ) : (
                            ""
                          )
                        ) : (
                          <div className="col-xxl-12 col-sm-12 pd-xs-l-30 d-inline-flex align-items-start justify-content-end justify_mob_filter scrolling-carousel">
                            <div className="custm-filter">
                              <div>
                                <label className="form-label text-left pd-b-2 mb-0">
                                  Search Applied On
                                </label>
                              </div>
                              <div className="filter_bg_cust">
                                <span>
                                  Status - {this.state.pay_status_lable}
                                </span>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    )}

                    <div className="col-xxl-12 col-sm-12 pd-lg-r-15 pd-xs-r-15">
                      <div className="wh-payout-kpis">
                        {this.renderKpiCard(
                          "FF&E Brokerage Fee",
                          this.state.totalOwed,
                          this.state.totalPaid,
                        )}
                        {this.renderKpiCard(
                          "Introductory Brokerage Fee",
                          this.state.totalIntroOwed,
                          this.state.totalIntroPaid,
                        )}
                      </div>
                    </div>

                    <div className="scrolling-carousel pd-l-15 scroll-slide">
                      <Tab.Container
                        id="left-tabs-example"
                        defaultActiveKey="all"
                        onSelect={(e) => this.getActiveClass(e)}
                        eventKey={this.state.activeClass}
                        className="pd-r-60"
                      >
                        <Tab.Content className="m-0">
                          <div className="dashboardRightcard background-none pt-0 pd-l-30 pd-r-30">
                            <div className="mg-t-18 brandList pd-l-15 pd-r-15 Report_table earning-report-tbl ">
                              <div className=" pd-lg-l-0 pd-xs-l-0">
                                <div className="scroll-report-table">
                                  {/* ReactDatatable renders its own flat <thead> with no
                                      support for a parent/group header row (checked the
                                      library source — no such prop exists), so the FF&E /
                                      Introductory grouping is this separate bar sitting on
                                      top. Its 3 equal sections line up with the 9 table
                                      columns because this table's existing CSS
                                      (.resident-payout-table th) already gives every column
                                      the same min-width, so 3 columns per group is really
                                      3 equal thirds either way. */}
                                  <ReactDatatable
                                    className="table no-wrap mg-b-30 pd-b-2  brandtable border earning_reports resident-payout-table wh-payout-grouped-table"
                                    config={this.state.config}
                                    records={this.recordsWithTotals()}
                                    columns={this.state.columns}
                                    extraButtons={this.state.extraButtons}
                                    dynamic={true}
                                    total_record={this.state.total_record}
                                    onChange={this.tableChangeHandler}
                                    onRowClicked={this.rowClickedHandler}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </Tab.Content>
                      </Tab.Container>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </main>

        {/* Search modal */}
        <Modal
          show={this.state.isSearch}
          className="modal-large searchModalbox"
          centered
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              this.filterData();
            }
          }}
        >
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span className="welcomeClose" onClick={() => this.searchToggle()}>
              {global.closee}
            </span>
            <h3 className="text-center">Search Payout Report</h3>
            <div className="row col-12 m-0 pd-lg-l-15 pd-lg-r-15 pd-xs-l-0 pd-xs-r-0">
              <div className="col-lg-6 col-md-6 col-sm-12 pd-lg-l-15 pd-lg-r-15 pd-sm-l-15 pd-sm-r-15 pd-xs-l-0 pd-xs-r-0">
                <InputGroup className="mt-3" ref={this.checkInToDateInputGroupRef}>
                  <label>Check In To Date</label>
                  <div className="col-md-12 p-0">
                    <DatePicker
                      className="form-control max_width_100"
                      showMonthDropdown
                      showYearDropdown
                      scrollableYearDropdown
                      disabledKeyboardNavigation
                      strictParsing
                      autoComplete="off"
                      yearDropdownItemNumber={global.yearDropdownItemNumber}
                      name="end_date"
                      selected={this.state.end_date}
                      dateFormat="MM/dd/yy"
                      onChange={(data) =>
                        this.changeHandler({
                          target: {
                            type: "date",
                            name: "end_date",
                            value: data,
                          },
                        })
                      }
                      popperPlacement={this.state.checkInToDatePlacement}
                      onCalendarOpen={this.checkCheckInToDatePlacement}
                      popperModifiers={{
                        preventOverflow: {
                          enabled: true,
                          escapeWithReference: false,
                        },
                      }}
                    />
                  </div>
                </InputGroup>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 pd-lg-l-15 pd-lg-r-15 pd-sm-l-15 pd-sm-r-15 pd-xs-l-0 pd-xs-r-0">
                <InputGroup className="mt-3" ref={this.checkInFromDateInputGroupRef}>
                  <label>Check In From Date</label>
                  <DatePicker
                    className="form-control max_width_100"
                    showMonthDropdown
                    showYearDropdown
                    scrollableYearDropdown
                    disabledKeyboardNavigation
                    strictParsing
                    autoComplete="off"
                    yearDropdownItemNumber={global.yearDropdownItemNumber}
                    name="start_date"
                    selected={this.state.start_date}
                    dateFormat="MM/dd/yy"
                    onChange={(data) =>
                      this.changeHandler({
                        target: {
                          type: "date",
                          name: "start_date",
                          value: data,
                        },
                      })
                    }
                    popperPlacement={this.state.checkInFromDatePlacement}
                    onCalendarOpen={this.checkCheckInFromDatePlacement}
                    popperModifiers={{
                      preventOverflow: {
                        enabled: true,
                        escapeWithReference: false,
                      },
                    }}
                  />
                </InputGroup>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 pd-lg-l-15 pd-lg-r-15 pd-sm-l-15 pd-sm-r-15 pd-xs-l-0 pd-xs-r-0">
                <InputGroup className="mt-3">
                  <label>FF&E Status</label>
                  <div className="col-md-12 p-0">
                    <Select
                      styles={customStyles}
                      isClearable={true}
                      className="multiselect"
                      menuPlacement="auto"
                      value={this.state.selectedPaymentStatusList}
                      options={this.state.paymentStatusList}
                      onChange={(value) =>
                        this.handleChangePaymentStatusList(value)
                      }
                      defaultValue={this.state.selectedPaymentStatusList}
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 2,
                        colors: {
                          ...theme.colors,
                          primary: "#fff",
                          primary75: "#000",
                          primary50: "#000",
                          primary25: "#000",
                        },
                      })}
                    />
                  </div>
                </InputGroup>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 pd-lg-l-15 pd-lg-r-15 pd-sm-l-15 pd-sm-r-15 pd-xs-l-0 pd-xs-r-0">
                <InputGroup className="mt-3">
                  <label>Intro Status</label>
                  <div className="col-md-12 p-0">
                    <Select
                      styles={customStyles}
                      isClearable={true}
                      className="multiselect"
                      menuPlacement="auto"
                      value={this.state.selectedIntroPaymentStatusList}
                      options={this.state.introPaymentStatusList}
                      onChange={(value) =>
                        this.handleChangeIntroPaymentStatusList(value)
                      }
                      defaultValue={this.state.selectedIntroPaymentStatusList}
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 2,
                        colors: {
                          ...theme.colors,
                          primary: "#fff",
                          primary75: "#000",
                          primary50: "#000",
                          primary25: "#000",
                        },
                      })}
                    />
                  </div>
                </InputGroup>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 pd-lg-l-15 pd-lg-r-15 pd-sm-l-15 pd-sm-r-15 pd-xs-l-0 pd-xs-r-0">
                <InputGroup className="mt-3">
                  <label>Unit</label>
                  <div className="col-md-12 p-0">
                    <Select
                      isMulti
                      styles={customStyles}
                      isClearable={true}
                      className="multiselect"
                      menuPlacement="auto"
                      value={this.state.selectedUnitList}
                      options={this.state.newUnitList}
                      onChange={(value) => this.handleChangeUnitList(value)}
                      defaultValue={this.state.selectedUnitList}
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 2,
                        colors: {
                          ...theme.colors,
                          primary: "#fff",
                          primary75: "#000",
                          primary50: "#000",
                          primary25: "#000",
                        },
                      })}
                    />
                  </div>
                </InputGroup>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 pd-lg-l-15 pd-lg-r-15 pd-sm-l-15 pd-sm-r-15 pd-xs-l-0 pd-xs-r-0">
                <InputGroup className="mt-3">
                  <label>Creditor</label>
                  <div className="col-md-12 p-0">
                    <Select
                      styles={customStyles}
                      isClearable={true}
                      className="multiselect"
                      menuPlacement="auto"
                      value={this.state.selectedCreditorList}
                      options={this.state.creditors.map((creditor) => ({
                        value: creditor.creditor_id,
                        label: creditor.creditor_name,
                      }))}
                      onChange={(value) => this.handleChangeCreditorList(value)}
                      defaultValue={this.state.selectedCreditorList}
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 2,
                        colors: {
                          ...theme.colors,
                          primary: "#fff",
                          primary75: "#000",
                          primary50: "#000",
                          primary25: "#000",
                        },
                      })}
                    />
                  </div>
                </InputGroup>
              </div>
            </div>

            <div className="d-flex justify-content-center mt-3 row">
              <button
                type="button"
                className="m-0 btn btn-outline-light btn-block"
                onClick={() => this.searchToggle()}
              >
                Cancel
              </button>
              <button
                type="button"
                className="m-0 btn btn btn-success btn-block"
                onClick={() => this.filterData()}
                disabled={this.state.isSubmit ? true : false}
              >
                {this.state.isSubmit ? global.loader : "Search"}
              </button>
            </div>
          </Modal.Body>
        </Modal>

        {/* Transfer step 1: balance + payable amount */}
        <Modal show={this.state.is_total} className=" searchModalbox1" centered>
          <Modal.Body className="width_402 p-4 border_radius_14 modal-body">
            <span className="welcomeClose" onClick={() => this.totalbill()}>
              {global.closee}
            </span>
            <h3 className="text-center">Send Transfer</h3>
            <div className="payout_modal_box">
              <p>
                Available Stripe Balance:{" "}
                <span>
                  $
                  {this.state.Stripebalance
                    ? global.onKeyPressEvent.numberWithCommasForDecimal(
                        this.state.Stripebalance,
                      )
                    : 0}
                </span>
              </p>
              <hr className="hr_cust" />
              <p>
                Payable Amount:{" "}
                <span>
                  $
                  {this.state.totalOwed
                    ? global.onKeyPressEvent.numberWithCommasForDecimal(
                        this.state.totalOwed,
                      )
                    : 0}
                </span>
              </p>
            </div>
            <div className="d-flex justify-content-center mt-3 row">
              <button
                type="button"
                className="m-0 btn btn btn-success btn-block"
                onClick={() => this.confirmPayClose()}
              >
                Confirm
              </button>
            </div>
          </Modal.Body>
        </Modal>

        {/* Transfer step 2: final confirmation */}
        <Modal
          show={this.state.confirmPay}
          className=" searchModalbox1 confirm_modal_box"
          centered
        >
          <Modal.Body className="width_402 p-4 border_radius_14 modal-body">
            <span
              className="welcomeClose"
              onClick={() => this.confirmPayClose()}
            >
              {global.closee}
            </span>
            <h3 className="text-center mt-3">
              Are you sure you want to transfer payable amount?
            </h3>
            <div className="row col-12 m-0">
              <div className="col-lg-12 col-md-12 col-sm-12 p-0">
                <div className="d-flex justify-content-center mt-3 row">
                  <button
                    type="button"
                    className="m-0 btn btn btn-success btn-block"
                    onClick={() => this.paymentpayout()}
                  >
                    {this.state.isTransfer ? global.loader : "Yes"}
                  </button>
                  <button
                    type="button"
                    className="mx-auto- m-0  btn btn-outline-light btn-block ml-3"
                    onClick={() => this.confirmPayClose()}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* Intro transfer step 1: balance + payable amount */}
        <Modal
          show={this.state.is_total_intro}
          className=" searchModalbox1"
          centered
        >
          <Modal.Body className="width_402 p-4 border_radius_14 modal-body">
            <span
              className="welcomeClose"
              onClick={() => this.totalbillIntro()}
            >
              {global.closee}
            </span>
            <h3 className="text-center">Send Intro Transfer</h3>
            <div className="payout_modal_box">
              <p>
                Available Stripe Balance:{" "}
                <span>
                  $
                  {this.state.Stripebalance
                    ? global.onKeyPressEvent.numberWithCommasForDecimal(
                        this.state.Stripebalance,
                      )
                    : 0}
                </span>
              </p>
              <hr className="hr_cust" />
              <p>
                Payable Amount:{" "}
                <span>
                  $
                  {this.state.totalIntroOwed
                    ? global.onKeyPressEvent.numberWithCommasForDecimal(
                        this.state.totalIntroOwed,
                      )
                    : 0}
                </span>
              </p>
            </div>
            <div className="d-flex justify-content-center mt-3 row">
              <button
                type="button"
                className="m-0 btn btn btn-success btn-block"
                onClick={() => this.confirmPayCloseIntro()}
              >
                Confirm
              </button>
            </div>
          </Modal.Body>
        </Modal>

        {/* Intro transfer step 2: final confirmation */}
        <Modal
          show={this.state.confirmPayIntro}
          className=" searchModalbox1 confirm_modal_box"
          centered
        >
          <Modal.Body className="width_402 p-4 border_radius_14 modal-body">
            <span
              className="welcomeClose"
              onClick={() => this.confirmPayCloseIntro()}
            >
              {global.closee}
            </span>
            <h3 className="text-center mt-3">
              Are you sure you want to transfer the Intro fee payable amount?
            </h3>
            <div className="row col-12 m-0">
              <div className="col-lg-12 col-md-12 col-sm-12 p-0">
                <div className="d-flex justify-content-center mt-3 row">
                  <button
                    type="button"
                    className="m-0 btn btn btn-success btn-block"
                    onClick={() => this.paymentpayoutIntro()}
                  >
                    {this.state.isTransferIntro ? global.loader : "Yes"}
                  </button>
                  <button
                    type="button"
                    className="mx-auto- m-0  btn btn-outline-light btn-block ml-3"
                    onClick={() => this.confirmPayCloseIntro()}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* Transfer success modal */}
        <Modal
          show={this.state.importTransferResponseModel}
          className="modal-xs recordDetailmodalbox"
          centered
        >
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span
              className="welcomeClose"
              onClick={() => this.closeTransferResponseModel()}
            >
              {global.closee}
            </span>
            <div className="row col-12 m-0">
              <div className="col-lg-12 col-md-12 col-sm-12 p-0">
                <div className="d-flex justify-content-between mt-0 row">
                  <div className="msg">
                    <img src={SuccessLogo} alt="transferIcon" />
                    <p>{this.state.successTranferMessage}</p>
                  </div>
                </div>
                {this.state.lastTransferResult &&
                  this.state.lastTransferResult.transferred &&
                  this.state.lastTransferResult.transferred.length > 0 && (
                    <div className="mt-2">
                      <strong>Transferred:</strong>
                      <ul className="mg-b-0">
                        {this.state.lastTransferResult.transferred.map(
                          (item, i) => (
                            <li key={i}>
                              {item.creditor_name}: $
                              {parseFloat(item.amount).toFixed(2)} (
                              {item.record_count} reservation
                              {item.record_count === 1 ? "" : "s"})
                            </li>
                          ),
                        )}
                      </ul>
                    </div>
                  )}
                {this.state.lastTransferResult &&
                  this.state.lastTransferResult.skipped &&
                  this.state.lastTransferResult.skipped.length > 0 && (
                    <div className="mt-2">
                      <strong>Skipped:</strong>
                      <ul className="mg-b-0">
                        {this.state.lastTransferResult.skipped.map(
                          (item, i) => (
                            <li key={i}>
                              {item.creditor_name}: $
                              {parseFloat(item.amount).toFixed(2)} —{" "}
                              {item.reason}
                            </li>
                          ),
                        )}
                      </ul>
                    </div>
                  )}
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* Manual, on-demand report email modal — independent of Export (which
            just downloads a file) and independent of the automated cadence
            schedule (which emails per-creditor reports on its own timer). */}
        <Modal
          show={this.state.sendReportModal}
          className="modal-large searchModalbox"
          centered
        >
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span
              className="welcomeClose"
              onClick={() => this.toggleSendReportModal()}
            >
              {global.closee}
            </span>
            <h3 className="text-center">Send Custom Range Report</h3>
            <p className="text-center">
              Emails the WH Payout Report for the selected date range to the
              same recipients as the automated report. This does not affect the
              automated cadence schedule.
            </p>
            <div className="row col-12 m-0 pd-lg-l-15 pd-lg-r-15 pd-xs-l-0 pd-xs-r-0">
              <div className="col-lg-6 col-md-6 col-sm-12 pd-lg-l-15 pd-lg-r-15 pd-sm-l-15 pd-sm-r-15 pd-xs-l-0 pd-xs-r-0">
                <InputGroup className="mt-3" ref={this.sendReportStartDateInputGroupRef}>
                  <label>Start Date</label>
                  <DatePicker
                    className="form-control max_width_100"
                    showMonthDropdown
                    showYearDropdown
                    scrollableYearDropdown
                    disabledKeyboardNavigation
                    strictParsing
                    autoComplete="off"
                    yearDropdownItemNumber={global.yearDropdownItemNumber}
                    name="sendReportStartDate"
                    selected={this.state.sendReportStartDate}
                    dateFormat="MM/dd/yy"
                    onChange={(data) =>
                      this.setState({ sendReportStartDate: data })
                    }
                    popperPlacement={this.state.sendReportStartDatePlacement}
                    onCalendarOpen={this.checkSendReportStartDatePlacement}
                    popperModifiers={{
                      preventOverflow: {
                        enabled: true,
                        escapeWithReference: false,
                      },
                    }}
                  />
                </InputGroup>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 pd-lg-l-15 pd-lg-r-15 pd-sm-l-15 pd-sm-r-15 pd-xs-l-0 pd-xs-r-0">
                <InputGroup className="mt-3" ref={this.sendReportEndDateInputGroupRef}>
                  <label>End Date</label>
                  <DatePicker
                    className="form-control max_width_100"
                    showMonthDropdown
                    showYearDropdown
                    scrollableYearDropdown
                    disabledKeyboardNavigation
                    strictParsing
                    autoComplete="off"
                    yearDropdownItemNumber={global.yearDropdownItemNumber}
                    name="sendReportEndDate"
                    selected={this.state.sendReportEndDate}
                    dateFormat="MM/dd/yy"
                    onChange={(data) =>
                      this.setState({ sendReportEndDate: data })
                    }
                    popperPlacement={this.state.sendReportEndDatePlacement}
                    onCalendarOpen={this.checkSendReportEndDatePlacement}
                    popperModifiers={{
                      preventOverflow: {
                        enabled: true,
                        escapeWithReference: false,
                      },
                    }}
                  />
                </InputGroup>
              </div>
            </div>
            <div className="d-flex justify-content-center mt-3 row">
              <button
                type="button"
                className="m-0 btn btn-outline-light btn-block"
                onClick={() => this.toggleSendReportModal()}
              >
                Cancel
              </button>
              <button
                type="button"
                className="m-0 btn btn btn-success btn-block"
                onClick={() => this.sendManualReport()}
                disabled={this.state.isSendingReport}
              >
                {this.state.isSendingReport ? global.loader : "Send"}
              </button>
            </div>
          </Modal.Body>
        </Modal>

        {/* Export modal */}
        <Modal show={this.state.isModel} className="modal-xs" centered>
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span className="welcomeClose" onClick={() => this.exportToggle()}>
              {global.closee}
            </span>
            <h3 className="text-center">Export</h3>
            <div className="row col-12 m-0">
              <div className="col-lg-12 col-md-12 col-sm-12 p-0">
                <InputGroup className="mt-0">
                  <label>Select Export File Type : </label>
                  <div className="row">
                    <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4 mg-t-5 mg-md-t-0 pd-lg-l-30 pd-lg-r-30 pd-xs-l-15 pd-xs-r-15 mg-b-15">
                      <Form.Check
                        onChange={(e) => this.changeExport(e)}
                        name="alert_type"
                        value="xlsx"
                        checked={this.state.alertType === "xlsx" ? true : false}
                        type={"radio"}
                        id="xlsx"
                        label={"XLSX"}
                        className={"rdiobox mg-r-20"}
                      />
                    </div>
                    <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4 mg-t-5 mg-md-t-0 pd-lg-l-30 pd-lg-r-30 pd-xs-l-15 pd-xs-r-15 mg-b-15">
                      <Form.Check
                        onChange={(e) => this.changeExport(e)}
                        name="alert_type"
                        value="csv"
                        checked={this.state.alertType === "csv" ? true : false}
                        type={"radio"}
                        id="csv"
                        label={"CSV"}
                        className={"rdiobox mg-r-20"}
                      />
                    </div>
                  </div>
                </InputGroup>

                {this.state.exportMesssage !== "" && (
                  <div>
                    {this.state.exportMesssage}
                    <br></br>
                    <br></br>
                  </div>
                )}
                <div className="d-flex justify-content-center mt-3">
                  <button
                    type="button"
                    className="mx-auto- mg-r-30 btn btn btn-success btn-block"
                    onClick={() => this.ExportData()}
                    disabled={this.state.isSubmit ? true : false}
                  >
                    {this.state.isSubmit ? global.loader : "Export"}
                  </button>
                  <button
                    type="button"
                    className="mx-auto- m-0  btn btn-outline-light btn-block"
                    onClick={() => this.exportToggle()}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
export default WHPayoutReport;
